export default __webpack_public_path__ + "static/media/ic-ngn.1c7f3088.svg";